import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom"; // new import

import "./App.scss";

const E404 = lazy(() => import("./views/e404/e404.js"));
const XlsxPdfViewer = lazy(() => import("./views/xlsx_viewer/xlsxviewer.tsx"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="xlsxviewer" element={<XlsxPdfViewer />} />
          <Route path="*" element={<E404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
